module.exports = __webpack_public_path__ + "static/media/aquecedor3.8ebd5a12.png";